<template>
  <div id="app">
    <div class="table">
      <search-bar ref="searchBarComponent">
        <div slot="search-tool">
          <!-- <el-button class="item-btn el-icon-plus" type="primary" @click="dialogVisible = true">新增</el-button> -->
        </div>
        <div slot="search-cont">
          <div class="item" style="width: 35%;">
            <div class="item-label">关键词搜索</div>
            <div style="width: 400px;">
              <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small"
                @keyup.enter.native='searchResume'>
                <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                  <el-option label="电话号码" value="2"></el-option>
                  <el-option label="反馈内容" value="1"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
              </el-input>
            </div>
          </div>

          <div class="item" style="width: 20%;">
            <div class="item-label">状态</div>
            <div style="width: 250px;">
              <el-select v-model="info.audit" slot="prepend" placeholder="请选择" style="width: 250px" size="small">
                <el-option label="全部" value=""></el-option>
                <el-option label="待处理" value="2"></el-option>
                <el-option label="已处理" value="1"></el-option>
              </el-select>
            </div>
          </div>

          <div class="item" style="width: 20%;">
            <div class="item-label">状态</div>
            <div style="width: 250px;">
              <el-date-picker v-model="info.time" type="daterange" range-separator="至" start-placeholder="开始日期"
               @change="timeChange" value-format="yyyy-MM-dd" end-placeholder="结束日期" size="small">
              </el-date-picker>
            </div>
          </div>

        </div>
      </search-bar>
      <div class="containers">
        <el-table :data="tableData" style="width: 100%;margin-top: 20px;" border>
          <el-table-column prop="addtime" label="时间" align='center'></el-table-column>
          <el-table-column prop="title" label="主题" align='center'></el-table-column>
          <el-table-column prop="feedback" label="反馈内容" align='center'>
            <template slot-scope='{row}'>
              <el-popover placement="top-start" width="200" trigger="hover" :content="row.feedback">
                <div slot="reference" class="feedbackContent">{{row.feedback}}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="用户" align='center'></el-table-column>
          <el-table-column prop="tel" label="用户电话" align='center'></el-table-column>
          <el-table-column prop="replycontent" label="回复内容" align='center'>
            <template slot-scope='{row}'>
              <el-popover placement="top-start" width="200" trigger="hover" :content="row.replycontent">
                <div slot="reference" class="feedbackContent">{{row.replycontent}}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="replytime" label="回复时间" align='center'></el-table-column>
          <el-table-column prop="addtime" label="操作" align='center'>
            <template slot-scope='{row}'>
              <el-button type="primary" :disabled="row.audit == 1" @click='answerSuggest(row)'>答复</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <div class="totalNumber">查询出{{total}}条数据</div>
          <el-pagination layout="prev, pager, next" :total="total" @current-change='paginationChange'></el-pagination>
        </div>


        <el-dialog title="新增黑名单" :visible.sync="dialogVisible" center width="30%">
          <el-form ref="form" :model="selectRow" label-width="80px">
            <el-form-item label="主题">
              <el-input v-model="selectRow.title" type="text" readonly />
            </el-form-item>
            <el-form-item label="反馈内容" class='feebackDialog'>
              <el-input type="textarea" v-model="selectRow.feedback" readonly />
            </el-form-item>

            <el-form-item label="回复">
              <el-input type="textarea" v-model="replycontent" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </span>
        </el-dialog>

      </div>
    </div>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          key_type: '1',
          key: '',
          page: 1
        },
        form: {
          mobile: '',
          remark: '',
          time:[]
        },
        tableData: [],
        total: 1,
        dialogVisible: false,
        selectRow: {},
        replycontent: ''
      }
    },
    created() {
      this.$nextTick(() => {
        document.onselectstart = new Function("event.returnValue=false");
      });
    },
    mounted() {
      this.getData()
    },

    methods: {
      searchResume() {
        if (!this.info.key_type) {
          return Message.warning('请选择类型')
        }
        this.info.page = 1
        this.getData()
      },

      timeChange(e){
        if(e){
          this.info.begintime = e[0];
          this.info.endtime = e[1];
        }else{
          this.info.time = [];
          this.info.begintime = '';
          this.info.endtime = '';
        }
        this.info.page = 1;
        this.getData()
      },

      paginationChange(val) {
        this.info.page = val
        this.getData()
      },

      getData() {
        this.gets('feedback/index', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      },

      submitForm() {
        let that = this
        if (this.replycontent) {
          let params = {
            replycontent: this.replycontent,
            id: this.selectRow.id
          }
          this.post('feedback/set_audit', params)
            .then(res => {
              that.getData()
              Message[res.data.code == 1 ? "success" : "warning"](res.data.msg)
              this.dialogVisible = res.data.code == 1 ? false : true
            })
        } else {
          Message.warning('请输入回复内容')
        }
      },

      answerSuggest(row) {
        console.log(row)
        this.selectRow = row
        this.dialogVisible = true
      },
    }
  }
</script>

<style scoped>
  .table {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
    padding: 20px 0;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .feebackDialog>>>textarea {
    resize: none;
  }

  .feedbackContent {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/reportindex.vue